<template>
  <b-row>
    <b-col cols="3"></b-col>
    <b-col>
      <b-row v-if="showPayments">
        <b-col>
          <h5 class="text-info fl-r">
            {{ $t("globals.one_time").toUpperCase() }}:
          </h5>
        </b-col>
        <b-col>
          <h5 class="fl-r">{{ currencyFormat(oneTime, currency) }}</h5>
        </b-col>
      </b-row>
      <b-row v-if="showPayments">
        <b-col>
          <h5 class="text-info fl-r">
            {{
              payments.toString() +
                " x " +
                $t("globals.payments").toUpperCase()
            }}:
          </h5>
        </b-col>
        <b-col>
          <h5 class="fl-r">{{ currencyFormat(onePayment, currency) }}</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h4 class="text-secondary fl-r">
            {{ $t("globals.initial_payment").toUpperCase() }}:
          </h4>
        </b-col>
        <b-col>
          <h4 class="text-secondary fl-r">
            {{ currencyFormat(subTotal, currency) }}
          </h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h5 class="text-secondary fl-r">
            {{ $t("globals.vat").toUpperCase() }}:
          </h5>
        </b-col>
        <b-col>
          <h5 class="text-secondary fl-r">
            {{ currencyFormat(vat, currency) }}
          </h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h4 class="text-info fl-r">
            {{ $t("globals.grand_total").toUpperCase() }}:
          </h4>
        </b-col>
        <b-col>
          <h4 class="fl-r">{{ currencyFormat(grandTotal, currency) }}</h4>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { currencyFormat } from "@/helpers/price";

export default {
  props: {
    showPayments: {
      type: Boolean,
      default: false
    },
    subTotal: {
      type: Number,
      default: 0
    },
    vat: {
      type: Number,
      default: 0
    },
    grandTotal: {
      type: Number,
      default: 0
    },
    payments: {
      type: Number,
      default: 0
    },
    oneTime: {
      type: Number,
      default: 0
    },
    onePayment: {
      type: Number,
      default: 0
    },
    currency: {
      type: String,
      default: "EUR"
    }
  },
  methods: {
    currencyFormat
  }
};
</script>

<style scoped>
.fl-r {
  float: right;
}
</style>
